import React from 'react';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaInstagram, FaFigma } from "react-icons/fa";

export default function Footer() {
  return (
    <div>
      <div className="flex justify-center items-center">
        <motion.ul
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex justify-center pb-10"
        >
          <motion.li
            whileHover={{ scale: 1.1 }}
            className="pl-4 md:pl-10"
          >
            <Link to="https://github.com/45aman"><FaGithub size="3.3rem" /></Link>
          </motion.li>
          <motion.li
            whileHover={{ scale: 1.1 }}
            className="pl-4 md:pl-10"
          >
            <Link to="https://www.linkedin.com/in/aman-shaikh-671b60226/"><FaLinkedin size="3.3rem" /></Link>
          </motion.li>
          <motion.li
            whileHover={{ scale: 1.1 }}
            className="pl-4 md:pl-10"
          >
            <Link to="https://www.instagram.com/_amu_456_/"><FaInstagram size="3.3rem" /></Link>
          </motion.li>
          <motion.li
            whileHover={{ scale: 1.1 }}
            className="pl-4 md:pl-10"
          >
            <Link to="https://www.figma.com/files/recents-and-sharing/recently-viewed?fuid=1087804051819283768"><FaFigma size="3.3rem" /></Link>
          </motion.li>
        </motion.ul>
      </div>
    </div>
  );
}
